<template>
  <div class="o-stepListing">
    <div class="stepListing__title">
      {{ $t(titleKey || 'components.stepListing.title', { fairName }) }}
    </div>

    <ul class="stepListing__list">
      <li
        class="list__item"
        v-for="step in fairSteps"
        :key="step.uuid"
        :class="{ 'is-active': step.isActive }"
      >
        <time class="item__content content--dodate">{{
          $d(new Date(step.dateRange.end), 'L')
        }}</time>
        <div class="item__content content--text">{{ step.displayName }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StepListing',
  props: {
    titleKey: {
      type: String,
      default: null
    },
    fairName: {
      type: String,
      default: ''
    },
    steps: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      now: new Date().getTime()
    }
  },
  computed: {
    fairSteps() {
      return this.steps
        .map(step => {
          step.startTime = this.getStartTime(step)
          step.endTime = this.getEndTime(step)
          step.isActive = this.now > step.startTime && this.now <= step.endTime

          return step
        })
        .sort((stepA, stepB) =>
          stepA.endTime < stepB.endTime
            ? -1
            : stepA.endTime > stepB.endTime
            ? 1
            : 0
        )
    }
  },
  methods: {
    getStartTime(step) {
      let startDate = new Date((step.dateRange || {}).start || 0)

      startDate.setUTCHours(0)
      startDate.setUTCMinutes(0)
      startDate.setUTCSeconds(0)
      startDate.setUTCMilliseconds(0)

      return startDate.getTime()
    },
    getEndTime(step) {
      let endDate = new Date((step.dateRange || {}).end || this.now)

      endDate.setUTCHours(23)
      endDate.setUTCMinutes(59)
      endDate.setUTCSeconds(59)
      endDate.setUTCMilliseconds(999)

      return endDate.getTime()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$stepListing-margin: $component-margin !default;

$stepListing-list-item-padding-y: 0.6rem !default;
$stepListing-list-item-padding-x: 0.2rem !default;

$stepListing-list-item-title-padding: $stepListing-list-item-padding-y
$stepListing-list-item-padding-x !default;
$stepListing-list-item-title-font-size: 0.75em !default;
$stepListing-list-item-title-font-weight: $font-weight-bold !default;

$stepListing-list-item-content-gap: $grid-gutter !default;

$stepListing-list-item-content-dodate-min-width: 7rem !default;

$stepListing-list-item-active-font-weight: $font-weight-bold !default;
$stepListing-list-item-active-font-color: $brand-primary !default;

.o-stepListing {
  margin: $stepListing-margin;
  margin-bottom: 2rem;

  .stepListing__title {
    font-weight: bold;
    color: $brand-primary;
    font-size: 2.125rem;
    margin-bottom: 2rem;
  }

  .stepListing__list {
    margin: 0 0 20px 0;
    padding: 0;
    list-style: none;
    position: relative;

    .list__item {
      position: relative;
      min-height: 50px;
      display: flex;
      justify-content: flex-start;
      margin-left: $stepListing-list-item-content-gap * -0.5;
      margin-right: $stepListing-list-item-content-gap * -0.5;
      padding: 15px $stepListing-list-item-padding-y 20px 50px;

      .item__content {
        padding-left: $stepListing-list-item-content-gap * 0.5;
        padding-right: $stepListing-list-item-content-gap * 0.5;


        &.content--dodate {
          min-width: $stepListing-list-item-content-dodate-min-width;
        }

        &.content--text {
        }
      }

      &:after {
        content: '';
        position: absolute;
        width: 40px;
        height: 40px;
        left: 8px;
        background-color: $brand-secondary;
        top: 7px;
        border-radius: 50%;
        z-index: 1;
      }

      &.item--title {
        padding: $stepListing-list-item-title-padding;
        font-size: $stepListing-list-item-title-font-size;
        font-weight: $stepListing-list-item-title-font-weight;

        .item__content {
          &.content--timeline {
            &:before,
            &:after {
              display: none;
            }
          }
        }
      }

      &.is-active {
        font-weight: $stepListing-list-item-active-font-weight;
        color: $stepListing-list-item-active-font-color;

        .item__content {
          &.content--timeline {
            &:after {
              display: block;
            }
          }
        }
        &:after {
          background-color: $brand-primary;
        }

      }
    }
    &:after {
      background-color: $brand-secondary;
      width: 2px;
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 20px;
    }
    &:before {
      content: '';
      position: absolute;
      left: 10px;
      top: 100%;
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid $brand-secondary;
      clear: both;
    }
  }
}
</style>
